var { useEffect } = require('react');
var { useSelector } = require('react-redux');
var { useCelebrationState } = require('./useUnicornAnimation');
var useCelebrationSound = require('./useCelebrationSound');

/**
 * Custom hook that manages unicorn celebration state
 *
 * This hook:
 * 1. Monitors field creation success
 * 2. Triggers the celebration when appropriate
 *
 * @returns {Object} - Celebration state and controls
 */
function useUnicornCelebration() {
  var celebrationState = useCelebrationState();
  var celebrationSound = useCelebrationSound();

  // Get field action status
  var fieldActions = useSelector(function (state) {
    return (
      (state.distribution_data && state.distribution_data.field_actions) || {}
    );
  });

  // Trigger celebration on field creation success
  useEffect(
    function () {
      if (
        fieldActions.status === 'success' &&
        fieldActions.type === 'CREATE' &&
        !celebrationState.isActive
      ) {
        try {
          celebrationState.startCelebration();
          celebrationSound.play();
        } catch (error) {
          // Fail silently - this is a delight feature, not critical functionality
          console.warn('Unicorn celebration failed to start:', error);
        }
      }
    },
    [fieldActions.status, fieldActions.type, celebrationState.isActive],
  );

  return {
    isActive: celebrationState.isActive,
    isFadingOut: celebrationState.isFadingOut,
    unicorns: celebrationState.unicorns,
    mode: celebrationState.mode,
    dismiss: celebrationState.dismiss,
    handleUnicornComplete: celebrationState.handleUnicornComplete,
  };
}

module.exports = useUnicornCelebration;
